<div class="usan-form-item antibody-drug-conjugates-container">
    <div class="usan-checklist-item">
        <div class="usan-checklist-icon-column">
        <mat-icon>{{ wasFileUploaded ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
        </div>
        <div class="usan-checklist-content-column">
        <span class="usan-form-item antibody-drug-conjugates-item antibody-drug-conjugates-text">
            Antibody-drug conjugates
            <ul>
              <li>All information required for monoclonal antibodies</li>
              <li>Editable ChemDraw file of the linker/payload combindation, showing which parts of the molecule are the linker and which parts are the payload</li>
              <li>Sites of attachment of the linker to the monoclonal antibody included in the MS-Word sequence document</li>
              <li *ngIf="formType === 'FormF'">Mandatory information for USAN selection and publication for nucleic acid-based substances including gene therapy substances and oligonucleotides. (Please note that incomplete requests will not be considered) <b>(MS-Word Documents Required)</b></li>
            </ul>
        </span>
        </div>
    </div>
    <div class="usan-form-item button-layout layout-centered">
        <button type="button" class="upload-antibody-drug-conjugates form-btn form-btn-style form-btn-text"
        (click)="openDialog()">
        <mat-icon class="form-btn-icon">upload</mat-icon>
        Upload antibody-drug conjugates documentation
        </button>
    </div>
    <ng-container *ngIf="wasFileUploaded">
    <div class="full-width" *ngFor="let file of attachments">
      <app-uploaded-file [requiresAdmin]="false" [attachment]="file"></app-uploaded-file>
    </div>
  </ng-container>
</div>